// apicontrol.ui/src/services/apiServicesService.ts
// COMPLETE VERSION with checkDependencies and delete methods
import api from './api';
import { ApiService, CreateApiServiceRequest } from '../types';

interface UpdateApiServiceRequest extends Partial<CreateApiServiceRequest> {
  isActive?: boolean;
}

interface ServiceDependencies {
  canDelete: boolean;
  permissionsCount: number;
  activePermissionsCount: number;
  usageRecordsCount: number;
  message: string;
}

export const apiServicesService = {
  getAll: () => api.get<ApiService[]>('/apiservices'),
  getById: (id: number) => api.get<ApiService>(`/apiservices/${id}`),
  getByGuid: (guid: string) => api.get<ApiService>(`/apiservices/guid/${guid}`),
  create: (data: CreateApiServiceRequest) => api.post<ApiService>('/apiservices', data),
  update: (id: number, data: UpdateApiServiceRequest) => api.put<ApiService>(`/apiservices/${id}`, data),
  
  // Check for dependencies before deletion
  checkDependencies: (id: number) => api.get<ServiceDependencies>(`/apiservices/${id}/dependencies`),
  
  // Delete service (only works if no dependencies)
  delete: (id: number) => api.delete(`/apiservices/${id}`),
};
